// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';

import '@/assets/style/reset.css'

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.use(ElementUI);

// 引入vue-resource工具类库
import VueResource from 'vue-resource'
// 引入vuex数据仓库
import Vuex from 'vuex'
Vue.use(VueResource)
Vue.use(Vuex)

// -------------------------------定义全局变量【开始】--------------------------
// 是否需要登录（指从大平台跳转过来）
Vue.prototype.isNeedLogin = true
// wechatApi
Vue.prototype.wechatApi = 'http://47.95.1.140/wx/wechat/'
Vue.prototype.userApi = "http://47.95.1.140/smartuser/smartuser/"
// 后台访问路径
// Vue.prototype.basePath = 'http://192.168.50.148:8091/drainagesystem'
// 项目名称为drainagesystem，因为后台下载图片方法写死了这个名称
Vue.prototype.basePath = 'http://47.95.1.140:7001/drainagesystem' //阿里云服务器地址
// 文件下载
Vue.prototype.fileDownloadPath = '/fileController/download/'
// 系统id
Vue.prototype.subsystemId = '1012'
// 是否显示基础配置tag（开发人员打包前用）
// Vue.prototype.ifShowBaseConfig = true
Vue.prototype.ifShowBaseConfig = false
// -------------------------------定义全局变量【结束】--------------------------

/**
 * 逻辑梳理：
 * 由于当前用户管理系统不太适用多单位这种动态控制权限，所以暂且设置两个组：
 * 一个排水户管理员组和一个排水户普通用户组，
 * 来控制大体的权限（包括是否可看系统设置页面，是否可新建排水户等功能等等权限）
 */

//定义全局map集合
Vue.prototype.basePathMap = new Map([
	['排水户信息管理', 101201],
	['排水户信息管理-查看', 10120101],
	['排水户信息管理-编辑', 10120102],
	['许可证勘察审批', 101202],
	['许可证勘察审批-查看', 10120201],
	['许可证勘察审批-编辑', 10120202],
	['排水户检查', 101203],
	['排水户检查-查看', 10120301],
	['排水户检查-编辑', 10120302],
	['统计分析', 101204],
	['配置管理', 101205]
])

//区域集合
Vue.prototype.regions = {
	"options": []
}

/**
 * 获取区域信息
 * @return {[type]} [description]
 */
Vue.prototype.filterRegion = function() {
	this.regions.options = [];
	this.regions.options.push({
		"text": -1,
		"value": "全部"
	});
	var regionInfoJson = '';
	var regionInfoStr = sessionStorage.getItem('drainage-regionInfo');
	if (regionInfoStr!='' && regionInfoStr!='null' && regionInfoStr!=null 
		&& typeof(regionInfoStr)!="undefined") {
		regionInfoJson = regionInfoStr;
	}else {
	    var companyInfo = sessionStorage.getItem('drainage-companyInfo');
	    if (companyInfo) {
	      var companyId = JSON.parse(companyInfo).CompanyId;
		  regionInfoJson = this.findRegionDataList(companyId);
	    } else {
	      this.$message({
	        type: 'error',
	        message: '登录信息过期，请重新登录'
	      });
	      this.$router.push({
	        path: '/login'
	      });
	    }		
	}
	if (regionInfoJson!='') {
		var regionInfoList = JSON.parse(regionInfoJson);
		for(var i=0;i<regionInfoList.length;i++) {
			var regionInfo = regionInfoList[i];
			this.regions.options.push({
				"text": regionInfo.id,
				"value": regionInfo.regionname
			});
		}	
	}else {
		this.$message({
          type: 'info',
          message: '区域数据为空，请进行区域配置，然后重新登录'
        });	
	}
	return this.regions.options;
}

/**
 * 全局方法-获取区域配置集合【main和system.vue共用】
 * @param  {[type]}   companyId [description]
 * @param  {Function} callback  [description]
 * @return {[type]}             [description]
 */
Vue.prototype.findRegionDataList = function(companyId) {
  	var resultJson = '';
  	var v = this;
    $.ajax({
        type: 'POST',
        url: this.basePath + '/sewerageUser/findRegionConfigList',
        contentType: "application/json",
        async: false,
        data: JSON.stringify({
        	companyId: companyId
        }),
        success: function (result) {
			if (result.resCode==1) {
		      if (result.data!='') {
		      	sessionStorage.setItem('drainage-regionInfo', result.data);
		      }else {
		      	sessionStorage.setItem('drainage-regionInfo', '');
		      }
		      resultJson = result.data;
		    } else {
		    	v.$message({
		          type: 'error',
		          message: result.msg
		        });  
		    }
        },
        error: function (des) {
		  v.$message({
	        type: 'error',
	        message: '获取区域数据异常'
	      });        	
        }
    }) 
    return resultJson; 
}

/**
 * 判断是否有权限代码
 * @param  {[type]} val [description]
 * @return {[type]}     [description]
 */
Vue.prototype.decidePower = function(val) {
	var moduleInfo = sessionStorage.getItem('drainage-moduleInfo');
	if (moduleInfo) {
		var moduleInfoList = JSON.parse(moduleInfo);
		//通过值获取权限编号
		var pwId = this.basePathMap.get(val);
		if(moduleInfoList.indexOf(pwId)!=-1) {
			return true;
		} else {
			return false;
		}		
	}else {
      this.$message({
        type: 'error',
        message: '登录信息过期，请重新登录'
      });
      this.$router.push({
        path: '/login'
      });		
	}
}

/*-----------------公共过滤器-----------------*/
// 通过毫秒数格式化时间
Vue.filter('formatTime_YMD', function(value) {
	if(value == 0) {
		return '';
	}
	var date = new Date(value);
	var y = date.getFullYear();
	var m = date.getMonth() + 1;
	m = m < 10 ? ('0' + m) : m;
	var d = date.getDate();
	d = d < 10 ? ('0' + d) : d;
	return y + '-' + m + '-' + d;
});
/*-----------------公共方法区-----------------*/
// 获取许可证状态
Vue.prototype.getStatusTextMain = function(value) {
	var text = '';
	if(value == '0') {
		text = '勘察中';
	} else if(value == '1') {
		text = '待审核';
	} else if(value == '2') {
		text = '审核不通过';
	} else if(value == '3') {
		text = '待批准';
	} else if(value == '4') {
		text = '批准不通过';
	} else if(value == '5') {
		text = '已发证';
	} else if(value == '6'){
		text = '勘察完成';
	} else {
		text = '';
	}
	return text;
};
/**
 * [time2YMD 时间格式化 日期毫秒转年月日]
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */
Vue.prototype.time2YMD = function(value) {
	if(value == 0) {
		return '';
	}
	var date = new Date(value);
	var y = date.getFullYear();
	var m = date.getMonth() + 1;
	m = m < 10 ? ('0' + m) : m;
	var d = date.getDate();
	d = d < 10 ? ('0' + d) : d;
	return y + '-' + m + '-' + d;
}
/**
 * [time2YMDHMS 时间格式化 日期毫秒转年月日时分秒]
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */
Vue.prototype.time2YMDHMS = function(value) {
	if(value == 0) {
		return '';
	}
	var date = new Date(value);
	var y = date.getFullYear();
	var m = date.getMonth() + 1;
	m = m < 10 ? ('0' + m) : m;
	var d = date.getDate();
	d = d < 10 ? ('0' + d) : d;
	var h = date.getHours();
	h = h < 10 ? ('0' + h) : h;
	var min = date.getMinutes();
	min = min < 10 ? ('0' + min) : min;
	var s = date.getSeconds();
	s = s < 10 ? ('0' + s) : s;
	return y + '-' + m + '-' + d + ' ' + h + ':' + min + ':' + s;
}
/**
 * [stringToDate 时间格式化 字符串转日期]
 * @param {Object} dateStr
 * @param {Object} separator
 */
Vue.prototype.stringToDate = function(dateStr,separator){
     if(!separator){
            separator="-";
     }
     var dateArr = dateStr.split(separator);
     var year = parseInt(dateArr[0]);
     var month;
     //处理月份为04这样的情况                         
     if(dateArr[1].indexOf("0") == 0){
         month = parseInt(dateArr[1].substring(1));
     }else{
          month = parseInt(dateArr[1]);
     }
     var day = parseInt(dateArr[2]);
     var date = new Date(year,month -1,day);
     return date;
 }

/**
 * 获取当前月份最后一天
 */
Vue.prototype.getMonthFirsetLastDay = function() {
	var arr = [];
	var date = new Date();
	var year = date.getFullYear() + "";
	var month = (date.getMonth() + 1) + "";
	// 本月第一天日期
	var begin = year + "-" + month + "-01";
	arr[0] = begin;
	// 本月最后一天日期    
	  
	var lastDateOfCurrentMonth = new Date(year, month, 0);   
	var end = year + "-" + month + "-" + lastDateOfCurrentMonth.getDate();
	arr[1] = end;
	return arr; 
}

/**
 *从Url获取参数
 */
Vue.prototype.getQueryString = function(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	var r = window.location.search.substr(1).match(reg);
	if(r != null) return decodeURI(r[2]);
	return null;
}

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js